<template>
    <div>
        <div class="cate_region_select">
            <div class="title">请选择类别</div>
            <div class="select_wrap" v-if="cateList.length">
                <Tree :data="cateList" :render="cateRender" show-checkbox expand-node select-node multiple
                    @on-check-change="cateChange"></Tree>
            </div>
            <div class="u-empty" v-if="cateListLoading">数据加载中...</div>
            <div class="u-empty" v-else-if="!cateListLoading && !cateList.length">
                暂无数据
            </div>
            <div class="title">请选择地区</div>
            <div class="select_wrap" v-if="regionList.length">
                <Tree :data="regionList" :render="cateRender" show-checkbox expand-node select-node multiple
                    ref="region" @on-check-change="regionChange"></Tree>
            </div>
            <div class="u-empty" v-if="regionListLoading">数据加载中...</div>
            <div class="u-empty" v-else-if="!regionListLoading && !regionList.length">
                暂无数据
            </div>
            <div class="title">请选择展区</div>
            <Collapse v-model="value1" :simple="true">
                <Panel name="1">
                    展区
                    <div class="select_wrap" v-if="zoneList.length" slot="content">
                        <Tree :data="zoneList" :render="cateRender" show-checkbox expand-node select-node multiple
                            @on-check-change="zoneChange"></Tree>
                    </div>
                </Panel>
            </Collapse>
            <div class="title" v-if="show">请选择展馆</div>
            <Collapse v-model="value2" :simple="true" v-if="show">
                <Panel name="2">
                    展馆
                    <div class="select_wrap" v-if="hallList.length" slot="content">
                            <div class="hall-btn-group">
                                <div
                                    v-for="item in hallList"
                                    :key="item.id"
                                    class="hall-btn"
                                    :class="{ active: selectedHall === item.name }"
                                    @click="hallChange(item.name)"
                                >
                                    {{ item.name }}
                                </div>
                            </div>

                    </div>
                </Panel>
            </Collapse>
            <div class="u-empty" v-if="zoneListLoading">数据加载中...</div>
            <div class="u-empty" v-else-if="!zoneListLoading && !zoneList.length">
                暂无数据
            </div>
        </div>
    </div>
</template>

<script>
import regionData from "@/assets/js/region.json"; //地区json
import { mapActions, mapMutations, mapGetters } from "vuex";
import axios from "axios";
export default {
    name: "categoryRegionSelect",
    props: {
        isProduct: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            cateList: [],
            regionList: [],
            cateListLoading: true,
            regionListLoading: true,
            zoneList: [],
            zoneListLoading: true,
            value1: '',
            value2: '',
            hallList: [],
            selectedHall: "",
            show: false,
        };
    },
    created () {
        this.init();
        // 仅当路由中包含“exhibitor”时才显示
        this.show = this.$route.path.includes('exhibitor');
        //   this.fetchHall();

    },
    computed: {
        ...mapGetters({
            selectCategories: "getSelectCategories", // 从store 获取存的展品类别
            exhibitionId: "getExhibitionId",
            exhibitionInfo: "getExhibitionInfo",
            cateArrVuex: "getCateArrVuex",
            regionArrVuex: "getRegionArrVuex",
        }),
    },
    methods: {
        ...mapMutations({
            setSelectCategories: "setSelectCategories",
        }),
        ...mapActions({
            graphqlPost: "graphqlPostByZXS",
        }),

        // 获取展馆
        async initHall () {
            let query = `
                query($exhibitionId: Guid!) {
                    getAllExHall(exhibitionId: $exhibitionId) {
                    createAt
                    deleteAt
                    description
                    exhibitionId
                    id
                    isDeleted
                    isFile
                    name
                    nameEn
                    shortName
                    shortNameEn
                    showIndex
                    }
                }
                `;
            let opt = {
                queryName: "hall",
                query: query,
                variables: {
                    exhibitionId: this.exhibitionId,
                },
            };
            let res = await this.graphqlPost(opt);
            let data = res.data.getAllExHall || [];
            this.hallList = data;


        },



        //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
        getList (arrJson) {
            let classArr = [];
            let isVuexRegion = this.regionArrVuex && this.regionArrVuex.length;
            arrJson.forEach((el) => {
                let mode = {
                    id: el.id,
                    name: el.name,
                };
                if (isVuexRegion) {
                    let item = this.regionArrVuex.find((obj) => obj.id === el.id);
                    if (item) {
                        mode.checked = true;
                    }
                }
                classArr.push(mode);
            });
            return classArr;
        },
        getRegionList (arrJson, isLists = true) {
            let classArr = [];
            let isVuexRegion = this.regionArrVuex && this.regionArrVuex.length;
            if (isLists) {
                arrJson.forEach((el) => {
                    let mode = {
                        id: el.id,
                        name: el.name,
                        expand: true,
                        children: this.getList(el.lists),
                    };
                    if (isVuexRegion) {
                        let item = this.regionArrVuex.find((obj) => obj.id === el.id);
                        if (item) {
                            mode.checked = true;
                        }
                    }
                    classArr.push(mode);
                });
            } else {
                arrJson.forEach((el) => {
                    let mode = {
                        id: el.id,
                        name: el.name,
                        expand: true,
                    };
                    if (isVuexRegion) {
                        let item = this.regionArrVuex.find((obj) => obj.id === el.id);
                        if (item) {
                            mode.checked = true;
                        }
                    }
                    classArr.push(mode);
                });
            }
            this.regionListLoading = false;
            return classArr;
        },
        async init () {
            let categoriesGql = `#graphql
          query($hostId:Guid!){
            categories :categoriesNoCache(hostId:$hostId){
              childrens :childrensNoCache{
                createAt
                icon
                id
                isDeleted
                level
                name
                nameEn
                parentId
                shortName
                shortNameEn
                showIndex
                updateAt
                childrens :childrensNoCache{
                  createAt
                  icon
                  id
                  isDeleted
                  level
                  name
                  nameEn
                  parentId
                  shortName
                  shortNameEn
                  showIndex
                  updateAt
                }
              }
              createAt
              icon
              id
              isDeleted
              banners
              level
              name
              nameEn
              parentId
              shortName
              shortNameEn
              showIndex
              updateAt
            }
          }`;
            let opt = {
                queryName: "categories",
                query: categoriesGql,
                variables: {
                    hostId: this.exhibitionId,
                },
            };
            let res = await this.graphqlPost(opt);
            let data = res.data.categories || [];
            let isVuex = this.cateArrVuex && this.cateArrVuex.length;
            data.sort((a, b) => {
                return a.showIndex - b.showIndex;
            });
            data.map((e) => {
                e.expand = true;
                if (e.childrens && e.childrens.length) {
                    e.childrens.sort((a, b) => {
                        return a.showIndex - b.showIndex;
                    });
                }
                e.children = e.childrens;
                if (isVuex) {
                    let item = this.cateArrVuex.find((obj) => obj.id === e.id);
                    if (item) {
                        e.checked = true;
                    }
                }
                if (this.selectCategories) {
                    if (e.id === this.selectCategories.id) {
                        this.$emit("cateChange", [e]);
                        e.checked = true;
                        return;
                    }
                }
                if (!e.childrens) return;
                e.childrens.forEach((v) => {
                    if (v.childrens && v.childrens.length) {
                        v.childrens.sort((a, b) => {
                            return a.showIndex - b.showIndex;
                        });
                    }
                    if (this.selectCategories) {
                        if (v.id === this.selectCategories.id) {
                            v.checked = true;
                            this.$emit("cateChange", [v]);
                            return;
                        }
                    }
                    if (isVuex) {
                        let item = this.cateArrVuex.find((obj) => obj.id === v.id);
                        if (item) {
                            v.checked = true;
                        }
                    }
                });
            });
            this.setSelectCategories(""); // 展品类别赋值后清空

            // 第三级改变 v.children = v.childrens;
            data.forEach((e) => {
                if (e.children && e.children.length) {
                    e.children.forEach((v) => {
                        if (v.childrens && v.childrens.length) {
                            v.children = v.childrens;
                        }
                    })
                }
            })
            this.cateList = data;
            console.log(this.cateList, '5555555555555555555');

            this.cateListLoading = false;
            this.regionList = this.getRegionList(regionData);
            this.fetchZoneList(); // 获取展区
            this.initHall(); // 获取展馆
        },
        //类别树自定义
        cateRender (h, { root, node, data }) {
            return h("span", {}, [
                h("span", [
                    h(
                        "span",
                        {
                            attrs: {
                                title: data.name,
                            },
                        },
                        data.name
                    ),
                ]),
            ]);
        },
        //类别树点击复选框
        cateChange (arr, e) {
            this.$store.commit("setCateArrVuex", arr);
            this.$emit("cateChange", arr);
        },
        //地区tree点击复选框
        regionChange (arr, e) {
            this.$store.commit("setRegionArrVuex", arr);
            console.log(arr, e);
            let returnArr = [];
            arr.forEach((c) => {
                if (c.expand) {
                    returnArr.push(c.name);
                } else {
                    let str = this.getAreaName(c.id);
                    if (returnArr.length) {
                        let isPush = true;
                        for (let i = 0; i < returnArr.length; i++) {
                            if (str.indexOf(returnArr[i]) != -1) {
                                isPush = false;
                                break;
                            }
                        }
                        if (isPush) {
                            returnArr.push(str);
                        }
                    } else {
                        returnArr.push(str);
                    }
                }
            });
            this.$emit("regionChange", returnArr);
        },
        //获取地区id对应的name和父级name(我的)
        getAreaName (areaId) {
            for (let i = 0; i < this.regionList.length; i++) {
                let list = this.regionList[i].children;
                for (let j = 0; j < list.length; j++) {
                    if (areaId == list[j].id) {
                        return `${this.regionList[i].name}/${list[j].name}`;
                    }
                }
            }
        },
        async fetchZoneList () {
            this.zoneListLoading = true;
            const { data } = await this.$http.get(
                `/api/v4/exhibitor/booth-zone?exhibitionId=${this.exhibitionId}`
            );
            let list = Array.isArray(data)
                ? data
                : data && data.data
                    ? data.data
                    : [];
            list = Array.from(new Set(list));   
            this.zoneList = list.map((name) => ({ id: String(name), name }));
            this.zoneListLoading = false;
        },
        zoneChange (arr) {
            const names = arr.map((c) => c.name);
            this.$emit("zoneChange", names);
            console.log("zoneChange", names);
        },
        hallChange (names) {  // boothHall: "S12"
            // 点击已选中的展馆则取消选中，否则选中当前展馆
            this.selectedHall = this.selectedHall === names ? '' : names;
            this.$emit("hallChange", this.selectedHall);
            console.log("hallChange", names);
        },


        async fetchHall () {
            const { data } = await this.$http.post(
                `/v1/exhall/find`, {
                "where": {
                    "Equal": {
                        "N": "exhibitionId",
                        "V": "de8987b2-c5a1-4260-a8b9-28dde7a6027c"
                    },
                    "Equal_isdeleted": {
                        "n": "isDeleted",
                        "v": false
                    }
                },
                "order": [
                    {
                        "N": "showIndex",
                        "V": 1
                    }
                ]
            }
            );
            let list = Array.isArray(data)
                ? data
                : data && data.data
                    ? data.data
                    : [];
            list = Array.from(new Set(list));
            this.zoneList = list.map((name) => ({ id: String(name), name }));
            this.zoneListLoading = false;
        },

    },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/my-theme/mixin.scss";

.cate_region_select {
    margin-right: 20px;
    background: #fff;
    width: 260px;
    border: solid 1px #ededed;
    border-top: none;
    padding: 20px;
    position: relative;
    margin-bottom: 20px;
    flex-shrink: 0;

    &::before {
        position: absolute;
        content: "";
        display: block;
        @include background_color(#1890ff);
        height: 4px;
        top: 0;
        left: 0;
        right: 0;
    }

    .title {
        color: #333;
        font-size: 16px;
    }

    .select_wrap {
        max-width: 260px;
        overflow: hidden;
        margin-bottom: 10px;

        ::v-deep .ivu-tree {
            .ivu-tree-arrow {
                color: #999;
            }

            ul li {
                width: 100%;
            }

            .ivu-tree-title {
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: calc(100% - 36px);
            }

            .ivu-checkbox {
                &:hover {
                    .ivu-checkbox-inner {
                        border-color: #2d8cf0;
                    }
                }
            }
        }
    }
}


/* 覆盖第三方 Collapse 组件标题左侧内边距 */
::v-deep .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
    padding-left: 0;
}

::v-deep .ivu-collapse {
    border: none;
}

.hall-btn{
    cursor: pointer;
        width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
}
.active {
    color: #1890ff;
    background: #e6f7ff;
}
</style>
